interface ScoreWord {
    count: number;
    alternatives: { count: number; points: number }[];
}

export const calculateScore = (list: ScoreWord[]) => {
    return list
        .filter(word => word.count !== 0)
        .map(item => item.alternatives.filter(word => word.count !== 0).map(alt => alt.points))
        .reduce((acc, points) => {
            return acc + Math.max(...points);
        }, 0);
};
